import { EnvironmentUrls } from 'Roblox';
import loginModule from '../loginModule.js';

function loginService(httpService, loginConstants) {
  'ngInject';

  function getApiUrl(endpoint) {
    return EnvironmentUrls.authApi + endpoint;
  }

  function getAppSiteUrl(endpoint) {
    return EnvironmentUrls.authAppSite + endpoint;
  }

  function getApiGatewayUrl(endpoint) {
    return EnvironmentUrls.apiGatewayUrl + endpoint;
  }

  function getAuthTokenMetadata() {
    const url = getApiGatewayUrl(loginConstants.urls.authTokenMetadata);
    const urlConfig = {
      url
    };

    return httpService.httpGet(urlConfig);
  }

  function getMetadataV2() {
    const url = getApiUrl(loginConstants.urls.metaDataV2);
    const urlConfig = {
      url
    };
    return httpService.httpGet(urlConfig);
  }

  function login(params) {
    const url = getApiUrl(loginConstants.urls.loginApi);
    const urlConfig = {
      url
    };

    return httpService.httpPost(urlConfig, params, true);
  }

  function canVerifyCredentials(params) {
    const url = getApiUrl(loginConstants.urls.credentialsVerificationApi);
    const urlConfig = {
      url
    };

    return httpService.httpPost(urlConfig, params, true);
  }

  function verifyCredentials(params) {
    const url = getApiUrl(loginConstants.urls.credentialsVerificationSendApi);
    const urlConfig = {
      url
    };

    return httpService.httpPost(urlConfig, params, true);
  }

  function setReturnUrl(returnUrl) {
    window.Roblox.Auth = window.Roblox.Auth || {};
    window.Roblox.Auth.returnUrl = returnUrl;
  }

  function getReturnUrl() {
    return window.Roblox.Auth && window.Roblox.Auth.returnUrl;
  }

  function loginWithVerificationToken(userId, challengeId, verificationToken, rememberDevice) {
    return httpService.httpPost({
      url: `${EnvironmentUrls.authApi}/v3/users/${userId}/two-step-verification/login`
      }, {
        challengeId: challengeId,
        verificationToken: verificationToken,
        rememberDevice: rememberDevice
      });
  }
  
  const loginService = {
    login,
    canVerifyCredentials,
    verifyCredentials,
    setReturnUrl,
    getReturnUrl,
    getAuthTokenMetadata,
    getMetadataV2,
    loginWithVerificationToken
  };
  return loginService;
}

loginModule.factory('loginService', loginService);

export default loginService;
